export const useNetInfo = () => ({
  isConnected: true,
  isInternetReachable: true,
  type: 'wifi',
  details: {},
});

export const fetch = () => Promise.resolve({
  isConnected: true,
  isInternetReachable: true,
  type: 'wifi',
  details: {},
});

export const addEventListener = (callback) => {
  // Simulate connection
  callback({ isConnected: true, isInternetReachable: true });
  return () => {};
};

export default {
  useNetInfo,
  fetch,
  addEventListener,
};
